var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectStatusChanged(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 6,
    fill: "#FDF6DD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2591_1617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.667 18.6667V17C18.667 15.1591 20.1594 13.6667 22.0003 13.6667L27.0003 13.6667C28.8413 13.6667 30.3337 15.1591 30.3337 17V22C30.3337 23.841 28.8413 25.3334 27.0003 25.3334H25.3337M18.667 18.6667H17.0003C15.1594 18.6667 13.667 20.1591 13.667 22V27C13.667 28.841 15.1594 30.3334 17.0003 30.3334H22.0003C23.8413 30.3334 25.3337 28.841 25.3337 27V25.3334M18.667 18.6667H22.0003C23.8413 18.6667 25.3337 20.1591 25.3337 22V25.3334M17.0003 24.5L18.461 25.6686C18.8092 25.9472 19.3151 25.9022 19.6087 25.5666L22.0003 22.8334",
    stroke: "#AD7636",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2591_1617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectStatusChanged);
export default __webpack_public_path__ + "static/media/project_status_changed.91cd2f6fcf360a9d40f88a653c40fd89.svg";
export { ForwardRef as ReactComponent };